import { useLenis } from '@studio-freight/react-lenis';
import { useState } from 'react';
import Button from '@/components/elements/Button';
import ChevronUp from '@/icons/ChevronUp';
import type Lenis from '@studio-freight/lenis';

export const SCROLL_TO_TOP_BUTTON_VISIBLE_TARGET_SCROLL_THRESHOLD = 150;

const ScrollToTopButton = () => {
    const [visible, setVisible] = useState<boolean>(false);
    const lenis = useLenis(({ targetScroll }: Lenis) => {
        setVisible(Number(targetScroll) > SCROLL_TO_TOP_BUTTON_VISIBLE_TARGET_SCROLL_THRESHOLD);
    });

    return (
        <Button
            className={`fixed bottom-4 rounded bg-white/50 py-4 outline-offset-0 right-4 invisible ${visible ? 'animate-fadein' : 'animate-fadeout'}`}
            onClick={() => lenis.scrollTo(0)}
            variant={'outline'}
        >
            <ChevronUp />
        </Button>
    );
};

export default ScrollToTopButton;
